import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { CreateActionForm } from '../CreateAction';


export interface ActionTypeProps
{
	
}


const actionTypes =
[
	'Investigation',
	'Safety Check',
	'Inspection Check',
	'Work Order',
	'Requisition',
	'Inventory Check',
	'Modify Drawings',
	'General',
	'Record Value',
];


const ActionTypeSelect = () =>
{
	const { control } = useFormContext<CreateActionForm>();
	
	
	return (
		<FormControl>
			<Controller
				control={control}
				name={'action_type'}
				render={({ field: { value, onChange }}) => (
					<Autocomplete
						options={actionTypes}
						value={value}
						disablePortal
						onChange={(e, newValue) => onChange(newValue)}
						renderInput={(params) => <TextField {...params} label='Action Type'/>}
						sx={{ minWidth: '250px' }}
					/>
				)}
			/>
		</FormControl>
	);
};


export default ActionTypeSelect;